import { render, staticRenderFns } from "./modalFormNewEvents.vue?vue&type=template&id=f5ff616c&scoped=true"
import script from "./modalFormNewEvents.vue?vue&type=script&lang=js"
export * from "./modalFormNewEvents.vue?vue&type=script&lang=js"
import style0 from "./modalFormNewEvents.vue?vue&type=style&index=0&id=f5ff616c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ff616c",
  null
  
)

export default component.exports